import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <span class="formatted-selection">
  {{this.formattedContent}}
</span>
*/
{
  "id": "we18/nmO",
  "block": "[[[10,1],[14,0,\"formatted-selection\"],[12],[1,\"\\n  \"],[1,[30,0,[\"formattedContent\"]]],[1,\"\\n\"],[13]],[],false,[]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/multi-select/format-selected-content.hbs",
  "isStrictMode": false
});